export enum ButtonVariant {
  Primary = 'primary',
  Save = 'save',
  Cancel = 'cancel',
  Danger = 'danger',
}

export enum ButtonType {
  Button = 'button',
  Reset = 'reset',
  Submit = 'submit',
}
